// extracted by mini-css-extract-plugin
module.exports = {"browser":"_2b72j","addressBar":"_2FZmz","url":"_1tRtV","contentFrame":"_2iX7C"};